// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1A3d2","large":"styles_large__33Bjg"};